import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendarFiveDayComponent } from './five-day.component';
import { CalendarsService } from '../../services/calendar.service';
import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { ParkRowComponent } from './components/park-row/park-row.component';
import { ParkTableComponent } from './components/park-table/park-table.component';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { LoadingSpinnerModule } from '@finder/shared/components/loading-spinner/loading-spinner.module';
import { ScheduleTimeModule } from '@finder/shared/components/schedule-time/schedule-time.module';
import { SectionModule } from '@finder/shared/components/section/section.module';
import { InArrayPipeModule } from '@finder/shared/utils/pipes/in-array/in-array.module';

const exportableComponents = [
    CalendarFiveDayComponent,
    ParkRowComponent,
    ParkTableComponent
];

const exportableModules = [
    InArrayPipeModule,
    AnchorModule,
    FontIconModule,
    LoadingSpinnerModule,
    ScheduleTimeModule,
    SectionModule,
];

@NgModule({
    imports: [
        CommonModule,
        ...exportableModules,
    ],
    declarations: [
        exportableComponents,
    ],
    providers: [
        CalendarsService,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class CalendarsFiveDayModule { }
